import { getDatadogLogsInstance } from "./datadog-logs";

class Logger {
  private static instance: Logger | null = null;
  private static isCreatingInstance = false;
  private datadogLogs = getDatadogLogsInstance();

  // Private constructor prevents direct instantiation
  private constructor() {
    if (!Logger.isCreatingInstance) {
      throw new Error(
        "Cannot instantiate Logger directly. Use Logger.getInstance() instead.",
      );
    }
  }

  // Static method to get the singleton instance
  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.isCreatingInstance = true;
      Logger.instance = new Logger();
      Logger.isCreatingInstance = false;
    }
    return Logger.instance;
  }

  info(message: string, context?: Record<string, string | number | boolean>) {
    if (this.datadogLogs.getInitConfiguration()) {
      this.datadogLogs.logger.info(message, context);
    }
  }

  warn(message: string, context?: Record<string, string | number | boolean>) {
    if (this.datadogLogs.getInitConfiguration()) {
      this.datadogLogs.logger.warn(message, context);
    }
  }

  error(
    message: string,
    context?: Record<string, string | number | boolean>,
    error?: Error,
  ) {
    if (this.datadogLogs.getInitConfiguration()) {
      this.datadogLogs.logger.error(message, context, error);
    }
  }

  debug(message: string, context?: Record<string, string | number | boolean>) {
    if (this.datadogLogs.getInitConfiguration()) {
      this.datadogLogs.logger.debug(message, context);
    }
  }
}

// Export the singleton instance
export const logger = Logger.getInstance();

// Also export the class if needed for typing or testing
export { Logger };
